import React, { useState, useEffect } from 'react';
import { MenuIcon, X } from 'lucide-react';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center">
          <h1 className={`text-2xl font-bold ${isScrolled ? 'text-primary' : 'text-white'}`}>
            ECO<span className="text-accent">RIDE</span>
          </h1>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex space-x-8">
          <button 
            onClick={() => scrollToSection('features')}
            className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-primary' : 'text-white hover:text-accent'}`}>
            Features
          </button>
          <button 
            onClick={() => scrollToSection('models')}
            className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-primary' : 'text-white hover:text-accent'}`}>
            Models
          </button>
          <button 
            onClick={() => scrollToSection('testimonials')}
            className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-primary' : 'text-white hover:text-accent'}`}>
            Testimonials
          </button>
          <button 
            onClick={() => scrollToSection('about')}
            className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-primary' : 'text-white hover:text-accent'}`}>
            About
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-accent hover:bg-accent-dark text-white font-medium py-2 px-4 rounded-full transition-colors">
            Book Test Ride
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <X className={isScrolled ? 'text-gray-700' : 'text-white'} />
          ) : (
            <MenuIcon className={isScrolled ? 'text-gray-700' : 'text-white'} />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="container mx-auto px-4 py-2 flex flex-col">
            <button 
              onClick={() => scrollToSection('features')}
              className="py-3 text-gray-700 border-b border-gray-100 font-medium"
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('models')}
              className="py-3 text-gray-700 border-b border-gray-100 font-medium"
            >
              Models
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="py-3 text-gray-700 border-b border-gray-100 font-medium"
            >
              Testimonials
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="py-3 text-gray-700 border-b border-gray-100 font-medium"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="my-3 bg-accent hover:bg-accent-dark text-white font-medium py-2 px-4 rounded-full transition-colors"
            >
              Book Test Ride
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;